import React, { useState, useEffect } from 'react';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';

import useFetchSites from '../hooks/useFetchSites';
import useFetchDeclarations from '../hooks/useFetchDeclarations';
import useFetchLstDocs from '../hooks/useFetchDocs';
import useFetchDommages from '../hooks/useFetchDommages';

import GeneralTab from '../components/stats/GeneralTab';
import SiteTab from '../components/stats/SiteTab';
import DeclarationTab from '../components/stats/DeclarationTab';
import DommageTab from '../components/stats/DommageTab';
import ExpertiseTab from '../components/stats/ExpertiseTab';

import config from '../config/config';
import authHeader from '../config/authHeader';

function StatPage() {
    const { sites, fetchSites, loading: loadingS } = useFetchSites();
    const { declarations, fetchDeclarations, loading: loadingD } = useFetchDeclarations();
    const { lstDocs, fetchLstDocs, loading: loadingL } = useFetchLstDocs();
    const { dommages, fetchDommages, loading: loadingDo } = useFetchDommages();

    const [loadingEx, setLoadingEx] = useState(true);
    const [lstExpertises, setLstExpertises] = useState([]);

    const [statTab, setStatTab] = useState('General');

    useEffect(() => {
        fetchSites();
        fetchDeclarations();
        fetchLstDocs();
        fetchDommages();
    }, []);

    useEffect(() => {
        setLoadingEx(true);

        fetch(`${config.apiBaseUrl}/4DACTION/KST_getExpertises`, {
            method: 'GET',
            headers: authHeader()
        })
            .then((response) => response.json())
            .then((data) => {
                setLstExpertises(data);
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des rendez-vous:", error);
                setLoadingEx(false);
            });

        setLoadingEx(false);
    }, []);

    const handleStatTabChange = async (tab) => {
        setStatTab(tab);
    };

    const [siteFilters, setSiteFilters] = useState({
        societe: "Toutes",
        entite: "Toutes",
        etat: "Toutes",
        type: "Toutes",
        typeDomaineActivite: "Toutes",
        typeMarche: "Toutes",
        minDate: null,
        maxDate: null,
        withCost: false,
        hideArchived: false,
        hideCompleted: false,
    });

    const [declarationsFilters, setDeclarationsFilters] = useState({
        societe: "Toutes",
        entite: "Toutes",
        etat: "Toutes",
        type: "Toutes",
        typeOuvrage: "Toutes",
        typeMarche: "Toutes",
        minDate: null,
        maxDate: null,
        withCost: false,
        hideArchived: false,
        hideCompleted: false,
    });

    const [dommagesFilters, setDommagesFilters] = useState({
        societe: "Toutes",
        entite: "Toutes",
        etat: "Toutes",
        type: "Toutes",
        typeOuvrage: "Toutes",
        typeMarche: "Toutes",
        minDate: null,
        maxDate: null,
        withCost: false,
        hideArchived: false,
        hideCompleted: false,
    });

    const [expertiseFilters, setExpertiseFilters] = useState({
        ca: "Tous",
        cloture: "Tous",
        minDate: null,
        maxDate: null,
    });

    const ExByCA = lstDocs
        .filter(d => d._Type_Document === "Expertise" && d.CA)
        .reduce((acc, doc) => {
            const caCodes = doc.CA
                .split(' - ')
                .flatMap(code => code
                    .split(',')
                    .map(c => c.trim())
                    .map(c => c.replace(/\s+/g, ' '))
                    .map(c => c.replace(/\(.*\)/, '').trim())
                    .map(c => c.toUpperCase())
                );

            caCodes.forEach(ca => {
                acc[ca] = (acc[ca] || 0) + 1;
            });

            return acc;
        }, {});

    // console.log("Declas:",declarations, "Dommages:", dommages, "lstDocs:", lstDocs, "Sites:", sites);

    return (
        <div class="flex-1 p-6 lg:p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div class="items-center gap-2 grid grid-cols-5 bg-gray-200 mx-auto p-2 rounded-xl w-full">
                            <div>
                                <input type="radio" name="option" id="0" value="General" checked={statTab === "General"} onChange={() => handleStatTabChange("General")} class="peer hidden" />
                                <label for="0" class="block peer-checked:bg-orange-500 p-3 rounded-xl peer-checked:font-bold peer-checked:text-white text-center transition-all duration-300 ease-in-out cursor-pointer select-none">
                                    Général</label>
                            </div>
                            <div>
                                <input type="radio" name="option" id="1" value="Sites" checked={statTab === "Sites"} onChange={() => handleStatTabChange("Sites")} class="peer hidden" />
                                <label for="1" class="block peer-checked:bg-orange-500 p-3 rounded-xl peer-checked:font-bold peer-checked:text-white text-center transition-all duration-300 ease-in-out cursor-pointer select-none">
                                    Sites</label>
                            </div>
                            <div>
                                <input type="radio" name="option" id="2" value="Declas" checked={statTab === "Declas"} onChange={() => handleStatTabChange("Declas")} class="peer hidden" />
                                <label for="2" class="block peer-checked:bg-orange-500 p-3 rounded-xl peer-checked:font-bold peer-checked:text-white text-center transition-all duration-300 ease-in-out cursor-pointer select-none">
                                    Declarations</label>
                            </div>
                            <div>
                                <input type="radio" name="option" id="3" value="Dommages" checked={statTab === "Dommages"} onChange={() => handleStatTabChange("Dommages")} class="peer hidden" />
                                <label for="3" class="block peer-checked:bg-orange-500 p-3 rounded-xl peer-checked:font-bold peer-checked:text-white text-center transition-all duration-300 ease-in-out cursor-pointer select-none">
                                    Dommages</label>
                            </div>
                            <div>
                                <input type="radio" name="option" id="4" value="Expertises" checked={statTab === "Expertises"} onChange={() => handleStatTabChange("Expertises")} class="peer hidden" />
                                <label for="4" class="block peer-checked:bg-orange-500 p-3 rounded-xl peer-checked:font-bold peer-checked:text-white text-center transition-all duration-300 ease-in-out cursor-pointer select-none">
                                    Expertises</label>
                            </div>
                        </div>

                        {statTab === "General" && (
                            <GeneralTab sites={sites} declarations={declarations} dommages={dommages} lstDocs={lstDocs} ExByCA={ExByCA} loadingS={loadingS} loadingD={loadingD} loadingDo={loadingDo} loadingL={loadingL} loadingEx={loadingEx} />
                        )}
                        {statTab === "Sites" && (
                            <SiteTab sites={sites} declarations={declarations} lstDocs={lstDocs} filters={siteFilters} setFilters={setSiteFilters} loadingS={loadingS} loadingD={loadingD} />
                        )}
                        {statTab === "Declas" && (
                            <DeclarationTab declarations={declarations} sites={sites} filters={declarationsFilters} setFilters={setDeclarationsFilters} loadingD={loadingD} />
                        )}
                        {statTab === "Dommages" && (
                            <DommageTab dommages={dommages} filters={dommagesFilters} setFilters={setDommagesFilters} loadingDo={loadingDo} />
                        )}
                        {statTab === "Expertises" && (
                            <ExpertiseTab lstDocs={lstDocs} sites={sites} filters={expertiseFilters} setFilters={setExpertiseFilters} loadingL={loadingS} loadingS={loadingEx} />
                        )}

                    </div>
                </div>
            </div>
        </div>

    );
}

export default StatPage;
